/** Add, change, move and remove the rows of a component's list. */
export function useItems(props, name = 'items') {
  const items = () => props.attrs[name] ?? [];
  const write = (next) => props.set({ [name]: next });

  return {
    add: (blank) => write([...items(), JSON.parse(JSON.stringify(blank))]),
    change: (i, value) => write(items().map((item, j) => (j === i ? value : item))),
    patch: (i, fields) => write(items().map((item, j) => (j === i ? { ...item, ...fields } : item))),
    remove: (i) => write(items().filter((_, j) => j !== i)),
    move: (i, by) => {
      const next = [...items()];
      const [item] = next.splice(i, 1);
      next.splice(i + by, 0, item);
      write(next);
    },
  };
}
